import {defineMessages} from "@project/i18n";

export const serviceDescriptionFieldLabelIds = {
  language: "fields.service.description.language",
  text: "fields.service.description.text",
} as const;

export const serviceDescriptionFieldMessages = defineMessages({
  language: {
    id: "fields.service.description.language",
    defaultMessage: "Language",
    description: "Service description language label",
  },
  text: {
    id: "fields.service.description.text",
    defaultMessage: "Description",
    description: "Service description text label",
  },
});
